// extracted by mini-css-extract-plugin
export default {"peer_review_wrapper":"PeerReviews_peer_review_wrapper__pPvxn","review":"PeerReviews_review__qxjib"};